import React from "react";
import { css } from "@emotion/core";
import FadeLoader from "react-spinners/FadeLoader";

// Can be a string as well. Need to ensure each key-value pair ends with ;
const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;

class CustomSpinner extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true
    };
  }

  render() {
    return (
      <div className="sweet-loading">
        <FadeLoader
          css={override}
          height={15}
          width={5}
          radius={6}
          margin={8}
          // color={"#123abc"}
          loading={this.state.loading}
        />
        {/* <PulseLoader
          css={override}
          size={15}
          margin={8}
          loading={this.state.loading}
        /> */}
      </div>
    );
  }
}

export default CustomSpinner;